import React from 'react'
import styles from './index.module.css'

import {
  Grid,
  Typography,
  Link
} from '@material-ui/core'
import cn from 'classname'

export default ({ step, privacyManagementUrl }) => {
  return (
    <Grid container spacing={2} justify={'center'} className={cn(styles.container, (step !== 2) ? styles.doNotDisplay : null) }>
       <Typography className={styles.signinTypography}>
         Richiesta inviata!
       </Typography>
       <Typography className={styles.yourHelpTypography}>
         Il tuo contributo è importante
       </Typography>
       <Typography variant={'body1'}>
         Per tornare alla Home <Link className={styles.goBackLink} href={'/'}>clicca qui </Link>
       </Typography>
       {step === 2 && privacyManagementUrl && <Typography variant="body1" style={{ width: '100%', textAlign: 'center', marginTop: 16 }}>
         Conserva questo <Link href={privacyManagementUrl}>collegamento personale per gestire o revocare i consensi</Link>. Lo trovi anche nella ricevuta via email; se non arriva, conserva questo collegamento.
       </Typography>}
    </Grid>
  )
}
